export default {
  root: ({ props }) => ({
    class: [
      "inline-flex select-none align-bottom outline-transparent",
      "border-transparent rounded-full bg-neutral-300 dark:bg-dss-surface-100 font-normal",

      // Custom width and color for buttons
      "[&>button]:w-[120px]",
      "[&>button]:bg-neutral-300 dark:[&>button]:bg-dss-surface-100",
      "[&>button]:text-neutral-800 dark:[&>button]:text-dss-surface-500",
      "[&>button]:text-sm",

      // Selected state styles
      '[&>button[data-p-checked="true"]]:bg-white',
      'dark:[&>button[data-p-checked="true"]]:bg-dss-surface-300',
      'dark:[&>button[data-p-checked="true"]]:text-white',
      '[&>button[data-p-checked="true"]]:drop-shadow-md',
      '[&>button[data-p-checked="true"]]:hover:bg-white',
      'dark:[&>button[data-p-checked="true"]]:hover:bg-dss-surface-300',

      // Styles for all buttons (default)
      "[&>button]:flex-1",
      "[&>button]:px-4",
      "[&>button]:py-2",
      "[&>button]:text-sm",
      "[&>button]:border-transparent",
      "[&>button]:text-center",
      "[&>button]:cursor-pointer",
      "[&>button]:select-none",
      "[&>button]:rounded-full",
      "[&>button]:border-0",
      "[&>button]:outline-none",

      // Style for span inside button
      "[&>button>span>span]:font-medium",

      // Invalid State
      {
        "border-red-500 dark:border-red-400": props.invalid,
        "border-transparent": !props.invalid,
      },
    ],
  }),
};
